import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const NAMES = ['Valeria', 'Carolina', 'Daniela', 'Mariana', 'Sofía', 'Andrea', 'Isabella', 'Natalia', 'Gabriela', 'Luciana', 'Alejandra', 'Fernanda', 'Camila', 'Paula', 'Adriana', 'Juliana', 'Mónica', 'Lorena', 'Diana', 'Claudia', 'Verónica'];
const CITIES = ['Miami', 'Houston', 'Los Angeles', 'New York', 'Dallas', 'Chicago', 'Orlando', 'Phoenix', 'San Antonio', 'San Diego', 'Atlanta', 'Las Vegas', 'Denver', 'Tampa', 'Austin'];
const PHOTOS = ['https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=120&h=120', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=120&h=120', 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&q=80&w=120&h=120', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=120&h=120', 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&q=80&w=120&h=120', 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&q=80&w=120&h=120'];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    photo: ''
  });
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;
    let visibleTimer: NodeJS.Timeout;
    let nextTimer: NodeJS.Timeout;
    const showToast = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)],
        photo: PHOTOS[Math.floor(Math.random() * PHOTOS.length)]
      });
      setIsVisible(true);
      visibleTimer = setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 4000);
    };
    const scheduleNext = () => {
      const interval = Math.floor(Math.random() * (15000 - 8000) + 8000);
      nextTimer = setTimeout(showToast, interval);
    };
    const initialTimer = setTimeout(showToast, 3000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(visibleTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-292">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-20 md:bottom-6 left-1/2 md:left-6 -translate-x-1/2 md:translate-x-0 z-[55] bg-white rounded-2xl shadow-2xl border border-soft/40 p-3 md:p-4 w-[92%] max-w-[340px] flex items-start gap-3" data-id="element-293">
          <img src={data.photo} alt="" className="w-11 h-11 md:w-12 md:h-12 rounded-full object-cover border-2 border-blush shrink-0" data-id="element-294" />
          <div className="min-w-0 flex-1" data-id="element-295">
            <p className="text-xs md:text-sm text-ink/80 leading-snug mb-0.5" data-id="element-296">
              <span className="font-bold text-primary" data-id="element-297">{data.name}</span>
              <span data-id="element-298"> en {data.city} acaba de adquirir</span>
            </p>
            <p className="text-[11px] md:text-xs font-bold text-accent mb-1" data-id="element-299">
              EL CÓDIGO DEL CIERRE™ — $6.99
            </p>
            <div className="flex items-center gap-2" data-id="element-300">
              <div className="flex text-gold" data-id="element-301">
                {[...Array(5)].map((_, i) => <Star key={i} size={10} fill="currentColor" data-id="element-302" />)}
              </div>
              <span className="text-[10px] text-ink/50" data-id="element-303">hace un momento</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}